import React, { useState } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import Paper from 'components/Paper';
import Input from 'components/Input';
import Button from 'components/Button';
import config from 'Config';

const StyledStartView = styled.div`
  ${Button} {
    margin-top: ${({ theme }) => theme.spacing * 2}px;
  }
`;

const StartView = ({
  className, error, onSubmit, onChange,
}) => {
  const classes = ['StartView'];
  if (className) {
    classes.push(className);
  }

  const [emailAddress, setEmailAddress] = useState('');
  const [emailValid, setEmailValid] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!!emailAddress && !error) {
      onSubmit(emailAddress, emailValid);
    }
  };

  const handleEmailChange = (e) => {
    const valid = e.target.validity.valid;
    setEmailAddress(e.target.value);
    setEmailValid(valid);
    onChange(valid);
  };

  const legalPolicy = config.footerLinks.find((l) => l.id === 'legalPolicy').url;

  return (
    <StyledStartView>
      <h1>Manage your easycare account</h1>
      <p>Enter the email address you gave us in store to start</p>
      <Paper>
        <form onSubmit={handleSubmit} noValidate>
          <Input
            label="Email"
            type="email"
            placeholder="email address"
            value={emailAddress}
            error={error}
            onChange={handleEmailChange}
            focus
          />
          <Button
            type="submit"
            disabled={!emailAddress || !!error}
            fullWidth
            dataLayer={{ action: 'Login Portal', label: 'Continue' }}
          >
            Continue
          </Button>
        </form>
      </Paper>
      <p><strong>Privacy Policy and Terms &amp; Conditions</strong></p>
      <p>
        Your personal information provided to us will be used for the purposes
        of managing your easyCare subscription. It may be shared with members of
        Specsavers group of companies and our third-party partners who support
        our easyCare service. Please see our privacy policy which explains how
        we&apos;ll use it to communicate with you, including by email. You can
        change your mind at any time, just contact us. By clicking continue you
        agree to our&nbsp;
        <a
          href={legalPolicy}
          target="_blank"
          rel="noopener noreferrer"
        >
          Privacy Policy and Terms & Conditions
        </a>
      </p>
    </StyledStartView>
  );
};

StartView.displayName = 'StartView';

StartView.propTypes = {
  className: PropTypes.string,
  error: PropTypes.string,
  onSubmit: PropTypes.func.isRequired,
  onChange: PropTypes.func,
};

StartView.defaultProps = {
  className: null,
  error: null,
  onChange: null,
};

export default StartView;
